/**
 * An enumeration of the different display layouts supported by the application.
 *
 * @type {Record<string, string>}
 */
export const LAYOUTS = {
    HORIZONTAL_FILMSTRIP_VIEW: 'Horizontal',
    TILE_VIEW: 'Tile',
    VERTICAL_FILMSTRIP_VIEW: 'Vertical',
    STAGE_VIEW: 'Stage'
};
